import { useOfferFiltersDispatch, useOfferFiltersState, } from "../context/OfferFiltersContext";
import { useFilterTracking } from "../hooks/useFilterTracking";
import React from "react";
export default function ButtonGroup({ filter, facet, }) {
    var _a, _b;
    const { selectedState } = useOfferFiltersState();
    const dispatch = useOfferFiltersDispatch();
    const { trackFilterChange } = useFilterTracking();
    const param = filter.id;
    const current = (_a = selectedState[param]) !== null && _a !== void 0 ? _a : "";
    const items = Object.values((_b = facet === null || facet === void 0 ? void 0 : facet.facet_data) !== null && _b !== void 0 ? _b : {});
    function handleSelect(value) {
        trackFilterChange(filter, value ? [value] : []);
        dispatch({
            type: "set_selected",
            payload: Object.assign(Object.assign({}, selectedState), { [param]: value || undefined }),
        });
    }
    return (<div className="flex flex-wrap gap-2">
      {items.map((item) => (<button key={item.value} type="button" onClick={() => handleSelect(item.value)} disabled={item.disabled || !item.available} className={`px-4 py-2 rounded-lg text-sm font-medium border ${current === item.value
                ? "bg-gray-800 text-white border-gray-800"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"} ${item.disabled || !item.available ? "opacity-50 cursor-not-allowed" : ""}`}>
          {item.label}
        </button>))}
    </div>);
}
